import { Stack, Typography } from '@mui/material'
import { BackToLogin } from '../BackToLogin'

export const ErrorPage = () => {
  return (
    <Stack>
      <Typography align="center">Page not found. </Typography>
      <BackToLogin />
    </Stack>
  )
}

export default ErrorPage
